import { Component, OnDestroy, OnInit, forwardRef, Inject, Input } from '@angular/core';
//import { SecurityService } from '@infrastructure/Security/SecurityService';
//import { PrestacoesMorteValueObservableService } from '@infrastructure/Documents/PrestacoesPorMorteValueObserver';
import { ICardComponentInjectionToken } from '@infrastructure/RadioLabelDirective';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { ControlContainer, NgForm } from '@angular/forms';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';

@Component({
  selector: 'benefit-type',
  templateUrl: './benefit-type.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],

  standalone: false
})

export class BenefitTypeComponent implements OnInit, OnDestroy {

  @Input("yesNo")
  public yesNo: models.DimensionVM[];
/*  @Input() benefitChoosen: BenefitChoosen;*/
  //public BenefitChoosen = BenefitChoosen;

  @Input("cardData")
  public cardData: models.BenefitTypeVM = {} as models.BenefitTypeVM;

  @Input("itemList")
  public itemList: models.BeneficiaryListVM[] = {} as models.BeneficiaryListVM[];

  @Input("beneficiaryIdentification")
  public beneficiaryIdentification: models.BeneficiaryIdentificationVM = {} as models.BeneficiaryIdentificationVM;


  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  public anyBeneficiaryHasRDF: boolean = false
  public beneficiaryWithRDF_NIF: number = null



  public isVisibleSurvivalPensionBenefit = false
  public isVisibleReimbursementFuneralBenefit = false
  public isVisibleFuneralAllowanceBenefit = false



  constructor(private beneficiariesStateService: LegalRepresentationStateService  ) {
    
  }

  ngOnInit(): void {

    if (this.itemList.every(item => 'reimbursementFuneralBenefit' in item)) {
      this.anyBeneficiaryHasRDF = false
      this.beneficiaryWithRDF_NIF = null
      for (const beneficiary of this.itemList) {
        if (beneficiary.reimbursementFuneralBenefit) {
          this.anyBeneficiaryHasRDF = true
          this.beneficiaryWithRDF_NIF = beneficiary.NIF
          break
        }
      }
    }
  }

  ngOnDestroy(): void {

  }

  public toggleVisibilitySurvivalPensionBenefit() {
    this.isVisibleSurvivalPensionBenefit = !this.isVisibleSurvivalPensionBenefit
  }

  public toggleVisibilityReimbursementFuneralBenefit() {
    this.isVisibleReimbursementFuneralBenefit = !this.isVisibleReimbursementFuneralBenefit
  }

  public toggleVisibilityFuneralAllowanceBenefit() {
    this.isVisibleFuneralAllowanceBenefit = !this.isVisibleFuneralAllowanceBenefit
  }

  public isSurvivalPensionBenefitChanged(value: boolean) {
    this.cardData.survivalPensionBenefit = value;

    if (this.cardData.survivalPensionBenefit!== true) {
      this.cardData.survivalPensionBenefit = undefined;
    }
  }

  public isReimbursementFuneralBenefitChanged(value: boolean) {
    this.cardData.reimbursementFuneralBenefit = value ;

    if (this.cardData.reimbursementFuneralBenefit !== true) {
      this.cardData.funeralExpense = undefined;
    }
  }

  public isFuneralAllowanceBenefitChanged(value: boolean) {
    this.cardData.funeralAllowanceBenefit = value ;

    if (this.cardData.funeralAllowanceBenefit !== true) {
      this.cardData.livedWithDeceased = undefined;
    }
  }

  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }

  public isBenefitSMorRDF(): boolean {
    const result = this.cardData.funeralAllowanceBenefit?.toString() == 'true' ||
      this.cardData.reimbursementFuneralBenefit?.toString() == 'true';
    return result;
  }

  public isBenefitSMorSO(): boolean {
    const result = this.cardData.funeralAllowanceBenefit?.toString() == 'true' ||
      this.cardData.survivalPensionBenefit?.toString() == 'true';
    return result;
  }

}

